import { useEffect } from 'react';
import faviconPng from './images/isadoran_creed_favicon.png';

const Favicon = () => {
  useEffect(() => {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'icon');
      document.head.appendChild(link);
    }
    link.setAttribute('href', faviconPng);
  }, []);
  return null;
};

export default Favicon;


